import type { FC } from "react";

import { useRestoreScrollOnBack } from "@shared/hooks";
import { Routes, Route } from "@shared/react-router-dom";
import { ErrorBoundary } from "@unauthenticated/catalog/components";
import { openCatalogRoutes } from "@unauthenticated/catalog/data/openCatalogRoutes";
import { routes } from "@unauthenticated/catalog/routes";

const Pages: FC = () => {
  useRestoreScrollOnBack();

  const flippers = [];

  return (
    <ErrorBoundary to={openCatalogRoutes.catalog}>
      <Routes>
        {routes(flippers).map(({ key, ...rest }) => (
          <Route key={key} {...rest} />
        ))}
      </Routes>
    </ErrorBoundary>
  );
};

export { Pages };
